import { toast } from "react-toastify";
import { publicInstance } from "../../axios";

import {
  CLEAR_WISHLIST,
  GET_WISHLIST_FAILURE,
  GET_WISHLIST_START,
  GET_WISHLIST_SUCCESS,
  UPDATE_WISHLIST,
} from "../constants";

export const getWishListItems = () => (dispatch) => {
  dispatch({
    type: GET_WISHLIST_START,
  });

  publicInstance
    .get(`wishlist`)
    .then((res) => {
      if (res.data && res.data.status) {
        dispatch({
          type: GET_WISHLIST_SUCCESS,
          payload: res.data.data || [],
        });

        return res.data.data;
      } else {
        dispatch({
          type: GET_WISHLIST_FAILURE,
          payload: [],
        });

        return [];
      }
    })
    .catch((error) => {
      dispatch({
        type: GET_WISHLIST_FAILURE,
        payload: [],
      });
      return [];
    });
};

export const addToWishListAction = async (data) => {
  const postData = { product_id: data };
  return await publicInstance
    .post(`wishlist`, postData)
    .then((res) => {
      if (res.data && res.data.status === 200) {
        return res.data.data || [];
      } else {
        return [];
      }
    })
    .catch((error) => {
      toast.error("API stopped responding. Please try later");
      return {};
    });
};
export const deleteWishList = async (id) => {
  return await publicInstance
    .delete(`wishlist?id=${id}`)
    .then((res) => {
      if (res.data && res.data.status === 200) {
        return res.data.data || [];
      } else {
        return [];
      }
    })
    .catch((error) => {
      return {};
    });
};

export const updateWishList = (data) => (dispatch) => {
  dispatch({
    type: UPDATE_WISHLIST,
    payload: data,
  });
};
export const clearWishList = () => (dispatch) => {
  dispatch({
    type: CLEAR_WISHLIST,
  });
};
